// 平台首页
<template>
  <div>
	<el-row>
	  <el-col :span="24">
		  <el-carousel :interval="3000" arrow="always" ref="carousel" @click.native="linkTo">
		    <el-carousel-item v-for="(item, index) in bannerList" :index="item.index" :key="index">
		      <el-image :src="item.src" width="100%" height="100%" class="customFadeInDown delay-0-1s slow"></el-image>
			  <el-row type="flex" justify="start" v-if="item.index==1" style="position: relative;top: -29%;padding-left:7.5%;" ><el-image :src="banner_01_btn" @click="contact" style="border-radius: 1.25rem;"></el-image></el-row>
			  <el-row type="flex" justify="start" v-if="item.index==2" style="position: relative;top: -29%;padding-left:45.4%;" ><el-image :src="banner_02_btn" @click="contact" style="border-radius: 1.875rem;"></el-image></el-row>
		    </el-carousel-item>
		  </el-carousel>
	  </el-col>
	</el-row>
	<el-row type="flex" justify="center" style="padding:0 0rem;position:relative;z-index: 101;top:-14.5rem;height:0;">
	  <el-col :span="23" class="stat_bg">
		  <ul class="stat_ul">
			 <!-- <li :class="1==stat_hover?'stat_01_bg':'stat_01_bg_none'" @mouseenter="stat_hover_f(1)" @mouseleave="stat_blur_f()">
				  <p :class="1==stat_hover?'p_none':'p_block'"><el-image :src="stat_01" width="100%" height="100%"></el-image></p>
				  <p :class="1==stat_hover?'p2_none':'p2_block'">品牌公司旗下客服平台</p>
			  </li> -->
			  <li :class="2==stat_hover?'stat_02_bg':'stat_02_bg_none'" @mouseenter="stat_hover_f(2)" @mouseleave="stat_blur_f()">
			  				  <p :class="2==stat_hover?'p_none':'p_block customFadeInDown delay-0-1s slow'"><el-image :src="stat_02" width="100%" height="100%"></el-image></p>
			  				  <p :class="2==stat_hover?'p2_none':'p2_block customFadeInDown delay-0-1s slow'">交易总额{{ billTotal }}万元</p>
			  </li>
			  <li :class="3==stat_hover?'stat_03_bg':'stat_03_bg_none'" @mouseenter="stat_hover_f(3)" @mouseleave="stat_blur_f()">
			  				  <p :class="3==stat_hover?'p_none':'p_block customFadeInDown delay-0-1s slow'"><el-image :src="stat_03" width="100%" height="100%"></el-image></p>
			  				  <p :class="3==stat_hover?'p2_none':'p2_block customFadeInDown delay-0-1s slow'">需求总量{{ requirementTotal }}单</p>
			  </li>
			  <li :class="4==stat_hover?'stat_04_bg':'stat_04_bg_none'" @mouseenter="stat_hover_f(4)" @mouseleave="stat_blur_f()">
			  				  <p :class="4==stat_hover?'p_none':'p_block customFadeInDown delay-0-1s slow'"><el-image :src="stat_04" width="100%" height="100%"></el-image></p>
			  				  <p :class="4==stat_hover?'p2_none':'p2_block customFadeInDown delay-0-1s slow'">入驻企业{{ supplierTotal }}家</p>
			  </li>
			  <li :class="5==stat_hover?'stat_05_bg':'stat_05_bg_none'" @mouseenter="stat_hover_f(5)" @mouseleave="stat_blur_f()">
			  				  <p :class="5==stat_hover?'p_none':'p_block customFadeInDown delay-0-1s slow'"><el-image :src="stat_05" width="100%" height="100%"></el-image></p>
			  				  <p :class="5==stat_hover?'p2_none':'p2_block customFadeInDown delay-0-1s slow'">客服人才{{ agentTotal }}人</p>
			  </li>
		  </ul>
	  </el-col>
	</el-row>
	
	<el-row type="flex" justify="center" style="padding-top:3.75rem;" class="customFadeInDown delay-0-1s slow">
		<el-col :span="17" style="width:75.85%;">
			<ul class="ser_ul">
				<li style="font-size: 2.25rem;color:black;padding-bottom: 3.75rem;">服务范围</li>
				<li style="height: 5.5rem; line-height: 5.5rem;">
					<span><el-image style="width: 30%;" @mouseenter="ser_hover_f(1)" :src="ser_hover==1?voice_title_sel:voice_title"></el-image></span>
					<span><el-image style="width: 30%;" @mouseenter="ser_hover_f(2)" :src="ser_hover==2?online_title_sel:online_title"></el-image></span>
					<span><el-image style="width: 30%;" @mouseenter="ser_hover_f(3)" :src="ser_hover==3?mark_title_sel:mark_title"></el-image></span>
				</li>
				<!--
				<li class="right" @mouseenter="ser_hover_f(1)" :style="ser_hover==1?'color:blue;cursor:pointer':''">标注采集</li>
				<li class="right">|</li>
				<li class="right" @mouseenter="ser_hover_f(2)" :style="ser_hover==2?'color:blue;cursor:pointer':''">在线客服</li>
				<li class="right">|</li>
				<li class="right" @mouseenter="ser_hover_f(3)" :style="ser_hover==3?'color:blue;cursor:pointer':''">语音客服</li>
				-->
			</ul>
			<el-row :style="ser_hover==1?'display:block;padding: 0 4%;':'display:none'">
				<div><el-image :src="ser_voice"></el-image></div>
				<ul class="voice_content_ul">
					<li><el-image :src="voice_i_1" class="con_img"></el-image><span class="con_span">全场景客服电话营销邀约等服务</span></li>
					<li><el-image :src="voice_i_2" class="con_img"></el-image><span class="con_span">全程录音质检 保证客服语音质量</span></li>
					<li><el-image :src="voice_i_3" class="con_img"></el-image><span class="con_span">400等号码资源丰富</span></li>
					<li><el-image :src="voice_i_4" class="con_img"></el-image><span class="con_span">全网运营商线路接入</span></li>
				</ul>
				<div class="con_btn">
					<el-image :src="ser_fabao" style="cursor: pointer;" @click="contact"></el-image>
					<el-image :src="ser_detail" style="cursor: pointer;padding-left: 2%;display:none;" @click="contact"></el-image>
				</div>
			</el-row>
			<el-row :style="ser_hover==2?'display:block;padding: 0 4%;':'display:none'">
				<div><el-image :src="ser_online"></el-image></div>
				<ul class="online_content_ul">
					<li><el-image :src="online_i_1" class="con_img"></el-image><span class="con_span">服务于多种行业全场景</span></li>
					<li><el-image :src="online_i_2" class="con_img"></el-image><span class="con_span">回访销售类金牌客服</span></li>
					<li><el-image :src="online_i_3" class="con_img"></el-image><span class="con_span">数字化智能客服</span></li>
					<li><el-image :src="online_i_4" class="con_img"></el-image><span class="con_span">企业定制化客服体验</span></li>
				</ul>
				<div class="con_btn">
					<el-image :src="ser_fabao" style="cursor: pointer;" @click="contact"></el-image>
					<el-image :src="ser_detail" style="cursor: pointer;padding-left: 2%;display:none;" @click="contact"></el-image>
				</div>
			</el-row>
			<el-row :style="ser_hover==3?'display:block;padding: 0 4%;':'display:none'">
				<div><el-image :src="ser_mark"></el-image></div>
				<ul class="mark_content_ul">
					<li><el-image :src="mark_i_1" class="con_img"></el-image><span class="con_span">大数据标记分类</span></li>
					<li><el-image :src="mark_i_2" class="con_img"></el-image><span class="con_span">专业标注培训团队</span></li>
					<li><el-image :src="mark_i_3" class="con_img"></el-image><span class="con_span">高转化率可用数据</span></li>
					<li><el-image :src="mark_i_4" class="con_img"></el-image><span class="con_span">高质量AI数据</span></li>
				</ul>
				<div class="con_btn">
					<el-image :src="ser_fabao" style="cursor: pointer;" @click="contact"></el-image>
					<el-image :src="ser_detail" style="cursor: pointer;padding-left: 2%;display:none;" @click="contact"></el-image>
				</div>
			</el-row>
		</el-col>
	</el-row>
	
	<el-row type="flex" justify="center" class="customFadeInDown delay-0-1s slow" style="top:-15.25rem;">
		<el-col :span="17" style="width:75.85%;">
			<ul class="adv_ul">
				<!-- <li><el-image :src="adv_title" style="float:left;"></el-image></li> -->
				<li style="font-size: 2.25rem;color:black;">我们的优势</li>
			</ul>
			<el-row><el-image :src="adv_bg"></el-image></el-row>
			<ul class="box_list">
				<li @mouseenter="box_hover_f(1)" :style="box_hover==1?'color:blue':'color:black'">精细化客服</li>
				<li @mouseenter="box_hover_f(2)" :style="box_hover==2?'color:blue':'color:black'">通话可追踪</li>
				<li @mouseenter="box_hover_f(3)" :style="box_hover==3?'color:blue':'color:black'">匹配智能化</li>
				<li @mouseenter="box_hover_f(4)" :style="box_hover==4?'color:blue':'color:black'">监控自动化</li>
				<li @mouseenter="box_hover_f(5)" :style="box_hover==5?'color:blue':'color:black'">质检全量化</li>
				<li @mouseenter="box_hover_f(6)" :style="box_hover==6?'color:blue':'color:black'">信息安全化</li>
			</ul>
			<el-row :style="box_hover==1?'display:block':'display:none'" class="con"><el-image :src="customer_bg"></el-image></el-row>
			<el-row :style="box_hover==2?'display:block':'display:none'" class="con"><el-image :src="call_bg"></el-image></el-row>
			<el-row :style="box_hover==3?'display:block':'display:none'" class="con"><el-image :src="match_bg"></el-image></el-row>
			<el-row :style="box_hover==4?'display:block':'display:none'" class="con"><el-image :src="watch_bg"></el-image></el-row>
			<el-row :style="box_hover==5?'display:block':'display:none'" class="con"><el-image :src="check_bg"></el-image></el-row>
			<el-row :style="box_hover==6?'display:block':'display:none'" class="con"><el-image :src="infor_bg"></el-image></el-row>
		</el-col>
	</el-row>
	
	<el-row type="flex" justify="center" style="padding-top: 6.25rem;margin-top:-16rem;">
		<el-col :span="17" style="width:75.85%;">
			<ul class="case_ul">
				<!-- <li><el-image :src="case_title" style="float:left;"></el-image></li> -->
				<li style="font-size: 2.25rem;color:black;">服务案例</li>
			</ul>
			<ul class="case_list">
				<li style="padding-left:0;"><el-image :src="case_comm"></el-image></li>
				<li><el-image :src="case_hotel"></el-image></li>
				<li style="padding-right:0;"><el-image :src="case_finance"></el-image></li>
			</ul>
		</el-col>
	</el-row>
	
	<el-row type="flex" justify="center">
		<el-col :span="24" style="padding-top:2.875rem;">
			<el-image :src="baojia"></el-image>
			<div style="position: relative;height:0;"><el-image :src="contact_pic01" style="top:-6.875rem;cursor:pointer;" @click="contact"></el-image><el-image :src="contact_pic02" style="top:-6.875rem;cursor:pointer;padding-left: 0.5%;display:none;" @click="contact"></el-image></div>
		</el-col>
	</el-row>
  </div>
</template>

<style>
  @import "../../assets/css/common.css";
  @import "../../assets/css/animation.css";
  .el-image__inner--center{left:0;transform:translate(0%, 0%);}
  .el-carousel__container{
    height:50rem;
  }
  .stat_bg{
	  width: 75.85%;
  }
  .stat_ul{height: 10.0625rem;padding-left:0;margin:0;}
  .stat_ul li{float:left;list-style-type: none;padding: 0 4%;height:9.0625rem;width:17%;cursor:pointer;}
  .stat_ul li.stat_01_bg{background: url("../../assets/index_new/stat_01.png") no-repeat center;height:10.0625rem;margin-top:-0.5rem;}
  .stat_ul li.stat_02_bg{background: url("../../assets/index_new/stat_02.png") no-repeat center;height:10.0625rem;margin-top:-0.5rem;}
  .stat_ul li.stat_03_bg{background: url("../../assets/index_new/stat_03.png") no-repeat center;height:10.0625rem;margin-top:-0.5rem;}
  .stat_ul li.stat_04_bg{background: url("../../assets/index_new/stat_04.png") no-repeat center;height:10.0625rem;margin-top:-0.5rem;}
  .stat_ul li.stat_05_bg{background: url("../../assets/index_new/stat_05.png") no-repeat center;height:10.0625rem;margin-top:-0.5rem;}
  .stat_ul li.stat_01_bg_none{background: rgb(247,247,255);}
  .stat_ul li.stat_02_bg_none{background: rgb(247,247,255);}
  .stat_ul li.stat_03_bg_none{background: rgb(247,247,255);}
  .stat_ul li.stat_04_bg_none{background: rgb(247,247,255);}
  .stat_ul li.stat_05_bg_none{background: rgb(247,247,255);}
  
  ul.stat_ul p.p_none{display: none;}
  ul.stat_ul p.p_block{display: block;}
  ul.stat_ul p.p2_none{margin-top: 6.6rem;color:white;}
  ul.stat_ul p.p2_block{margin-top:0;color:black;}
  
  ul.ser_ul{list-style-type: none;padding: 0 0.3125rem 2.1875rem 0; /*height:7.5rem;*/margin:0;}
  ul.ser_ul li.left{float:left;}
  ul.ser_ul li.right{float:right;width:4.0625rem;height:1.5rem;line-height: 1.5rem;padding-top:4.125rem;}
  
  ul.adv_ul{list-style-type: none;padding: 3.75rem 0.3125rem 0 0; height:7.5rem;margin:0;}
  
  ul.box_list{list-style-type: none;padding: 2.25rem 8.25rem 0px 8.25rem;height:1.875rem;margin:0;}
  ul.box_list li {float: left;width: 12%;padding: 0 2.3%;cursor:pointer;}
  .con {padding: 0 3.45rem 0px 3.45rem;}
  
  ul.case_ul{list-style-type: none;padding: 3.75rem 0.3125rem 0 0; height:7.5rem;margin:0;}
  ul.case_list{list-style-type: none;margin:0;padding:0;height: 22rem;}
  ul.case_list li {float: left;width: 32%;padding: 0 0.9%;}
  
  ul.voice_content_ul, ul.online_content_ul, ul.mark_content_ul{list-style-type: none;position: relative;top: -26.5625rem;width: 30%;left: 58%;}
  ul.voice_content_ul li, ul.online_content_ul li, ul.mark_content_ul li{font-size: 1.25rem;height: 3.75rem;}
  ul.voice_content_ul li .con_img, ul.online_content_ul li .con_img, ul.mark_content_ul li .con_img{float: left;padding-right: 3%;}
  ul.voice_content_ul li .con_span, ul.online_content_ul li .con_span, ul.mark_content_ul li .con_span{float: left;}
  div.con_btn{width: 30%;position: relative;top: -24.5625rem;left: 61.2%;height:0;}
  
  .ad1{width:900px;height: 530px;}
  .ad2{width:900px;height: 200px;}
</style>

<script>
	import {
		statistics
	} from '@/api/index/index'
	import connect from '@/util/connect.js'
	export default {
		data() {
			return {
				bannerList: [
					/*{
						src: require("../../assets/index_new/index_ad_01.png"),
						index: 4,
						link:'/audit'
					},*/
					{
						src: require("../../assets/index_new_2022_v2/banner_02.png"),
						index: 3,
						link:'/'
					},
					{
						src: require("../../assets/index_new_2022_v2/banner_01.png"),
						index: 1,
						link:'/'
					},
					// {
					// 	src: require("../../assets/index_new_2022/banner_1.png"),
					// 	index: 1,
					// 	link:'/'
					// },
					{
						src: require("../../assets/index_new_2022_v2/banner_03.png"),
						index: 2,
						link:'/'
					}
					/*,
					{
						src: require("../../assets/index_new/banner_3.png"),
						index: 3,
						link:'/'
					}*/
				],
				requirementTotal: 0,
				agentTotal: 0,
				billTotal: 0,
				supplierTotal: 0,
				stat_01:require("../../assets/index_new/stat_01_icon.png"),
				stat_02:require("../../assets/index_new/stat_02_icon.png"),
				stat_03:require("../../assets/index_new/stat_03_icon.png"),
				stat_04:require("../../assets/index_new/stat_04_icon.png"),
				stat_05:require("../../assets/index_new/stat_05_icon.png"),
				ser_title:require("../../assets/index_new_2022/ser_title.png"),
				adv_title:require("../../assets/index_new/adv_title.png"),
				case_title:require("../../assets/index_new/case_title.png"),
				case_comm:require("../../assets/index_new/case_comm.png"),
				case_hotel:require("../../assets/index_new/case_hotel.png"),
				case_finance:require("../../assets/index_new/case_finance.png"),
				ser_voice:require("../../assets/index_new_2022/voice_content.png"),
				ser_online:require("../../assets/index_new_2022/online_content.png"),
				ser_mark:require("../../assets/index_new_2022/mark_content.png"),
				adv_bg:require("../../assets/index_new/adv_bg.png"),
				
				watch_bg:require("../../assets/index_new/watch_bg.png"),
				customer_bg:require("../../assets/index_new/customer_bg.png"),
				match_bg:require("../../assets/index_new/match_bg.png"),
				call_bg:require("../../assets/index_new/call_bg.png"),
				infor_bg:require("../../assets/index_new/infor_bg.png"),
				check_bg:require("../../assets/index_new/check_bg.png"),
				baojia:require("../../assets/index_new_2022_v2/baojia.png"),
				contact_pic:require("../../assets/index_new/contact_pic.png"),
				contact_pic01:require("../../assets/index_new_2022_v2/contact.png"),
				contact_pic02:require("../../assets/index_new_2022_v2/contact_pic02.png"),
				
				voice_title:require("../../assets/index_new_2022/voice_title.png"),
				online_title:require("../../assets/index_new_2022/online_title.png"),
				mark_title:require("../../assets/index_new_2022/mark_title.png"),
				
				voice_title_sel:require("../../assets/index_new_2022/voice_title_sel.png"),
				online_title_sel:require("../../assets/index_new_2022/online_title_sel.png"),
				mark_title_sel:require("../../assets/index_new_2022/mark_title_sel.png"),
				ser_fabao:require("../../assets/index_new_2022_v2/contact.png"),
				ser_detail:require("../../assets/index_new_2022/ser_detail.png"),
				
				voice_i_1:require("../../assets/index_new_2022/voice_i_1.png"),
				voice_i_2:require("../../assets/index_new_2022/voice_i_2.png"),
				voice_i_3:require("../../assets/index_new_2022/voice_i_3.png"),
				voice_i_4:require("../../assets/index_new_2022/voice_i_4.png"),
				online_i_1:require("../../assets/index_new_2022/online_i_1.png"),
				online_i_2:require("../../assets/index_new_2022/online_i_2.png"),
				online_i_3:require("../../assets/index_new_2022/online_i_3.png"),
				online_i_4:require("../../assets/index_new_2022/online_i_4.png"),
				mark_i_1:require("../../assets/index_new_2022/mark_i_1.png"),
				mark_i_2:require("../../assets/index_new_2022/mark_i_2.png"),
				mark_i_3:require("../../assets/index_new_2022/mark_i_3.png"),
				mark_i_4:require("../../assets/index_new_2022/mark_i_4.png"),
				
				banner_01_btn:require("../../assets/index_new_2022_v2/contact.png"),
				banner_02_btn:require("../../assets/index_new_2022_v2/contact.png"),
				
				stat_hover:0,
				ser_hover:3,
				box_hover:2
			}
		},
		mounted() {
			if (this.getCookie('popped') == ''){ //cookie 中没有 popped 则赋给他一个值（此时弹框显示）
			    document.cookie = "popped = yes";
				var cTime = new Date().getTime();
				console.log("cTime"+cTime);
				// console.log(typeof(cTime));
				//2022-12-31 00:00:00 1672416000000
				//2023-01-03 00:00:00 1672675200000
				//元旦
				if(cTime>=1672416000000 && cTime<1672675200000)this.open();
				//除夕春节
				// 2023-01-20 18:00:00 1674208800000
				// 2023-01-28 00:00:00 1674835200000
				if(cTime>=1674208800000 && cTime<1674835200000)this.open();
				//网站通知，例如更新维护等
				//2023-04-11 18:00:00
				//2023-04-12 00:00:00
				if(cTime>=1681207200000 && cTime<1681228800000)this.openTip();
			}
			
			this.statistics();
		},
		created(){
			connect.$emit('updateAdTopShow',false);  
		},
		methods: {
			linkTo () {
				let activeIndex = this.$refs.carousel.activeIndex
				this.$router.push(this.bannerList[activeIndex].link)
			},
			stat_hover_f(h){
				this.stat_hover=h;
			},
			stat_blur_f(){
				this.stat_hover=0;
			},
			ser_hover_f(h){
				this.ser_hover=h;
			},
			box_hover_f(h){
				this.box_hover=h;
			},
			//统计数据
			statistics() {
				statistics().then(res => {
					//console.log(res);
					if (res.status == 200) {
						this.requirementTotal = res.data.data.requirementTotal;
						//this.agentTotal = res.data.data.agentTotal+26000;
						this.agentTotal = res.data.data.agentTotal;
						this.billTotal = res.data.data.billTotal;
						this.supplierTotal = res.data.data.supplierTotal;
					}
				}).catch(err => {
					this.$message.error(err.msg)
				})
			},
			contact() {
				document.getElementById("nb_invite_ok").click();
			},
			open() {
				//const ad_xlmh_src = require("../../assets/index/pop1.png");
			    //     this.$alert('<img src="'+ad_xlmh_src+'" width="100%" height="383px" />', '', {
			    //       dangerouslyUseHTMLString: true,
					  // customClass:"ad1",
					  // showConfirmButton:false
			    //     });
				
					const ad_xlmh_src = require("../../assets/index_new_2022_v2/newyear.gif");
					    this.$alert('<img src="'+ad_xlmh_src+'" width="100%" height="100%" style="filter: hue-rotate(37deg);" />', '', {
					      dangerouslyUseHTMLString: true,
						  customClass:"ad1",
						  showConfirmButton:false
					    });
			      },
				  
				  openTip() {
				  	//const ad_xlmh_src = require("../../assets/index/pop1.png");
				      //     this.$alert('<img src="'+ad_xlmh_src+'" width="100%" height="383px" />', '', {
				      //       dangerouslyUseHTMLString: true,
				  		  // customClass:"ad1",
				  		  // showConfirmButton:false
				      //     });
				  	
				  		    this.$alert('<h3 style="text-align:center;">网站升级提醒</h3><p style="padding-left:1%;">尊敬的访客您好，网站定于18:00~24:00进行系统升级，在此期间无法登录注册，给您带来的不便敬请谅解。</p><p style="padding-top:2%;float:right;">客服帮运营团队2023.04.11</p>', '', {
				  		      dangerouslyUseHTMLString: true,
				  			  customClass:"ad2",
				  			  showConfirmButton:false
				  		    });
				        },
				  
				  getCookie(Name) { //cookie
				          var search = Name + "=";
				          var returnValue = "";
				          if (document.cookie.length > 0) {
				            var offset = document.cookie.indexOf(search);
				            if (offset !== -1) {
				              offset += search.length;
				              var end = document.cookie.indexOf(";", offset);
				              if (end == -1){
				                end = document.cookie.length;
				              }
				              returnValue = decodeURIComponent(document.cookie.substring(offset, end));
				            }
				          }
				          return returnValue;
				        }
		}
	}
</script>